import TextInput from "@/Atoms/Input/TextInput";
import {router, useForm} from "@inertiajs/react";
import {FormEventHandler, useEffect, useState} from "react";
import InputError from "@/Components/InputError";
import Modal from "@/Organisms/Modals/Modal";
import Checkbox from "@/Components/Checkbox";
import {relativeRoute} from "@/helpers/relativeRoute";
import axios from "axios";
import searchPrompt from "@/helpers/searchPrompt";
import {PlaceType} from "@/types/constants";


/**
 * @param onSubmit
 * @param onCancel
 * @param isOpen
 * @param isLoading
 * @param defaultValues
 * @param query
 * @param inputErrors
 */
export default (
  {
    onSubmit,
    onCancel,
    isOpen,
    isLoading,
    defaultValues,
    query,
  }: {
    onSubmit?: (input: any) => void
    onCancel?: () => void
    isOpen?: boolean,
    isLoading?: boolean
    defaultValues?: {}
    query: {
      first_name: string
      last_name: string
      birth_date: string
      placement_date: string
      deceased_date_from: string
      deceased_date_to: string
      province?: {
        id: string
        title: string
      }
      places: {
        id: string
        title: string
      }[]
      papers: {
        id: string
        title: string
      }[]

    }
  }) => {

  type FormProps = {
    name: string
    email: string
    query: any
    interval: 'daily'|'weekly'
    newsletter: boolean
  }
  const [errors, setErrors] = useState<any>([])
  const [isSend, setIsSend] = useState<boolean>(false)

  const {data, setData, reset} = useForm<FormProps>({
    name: '',
    email: '',
    query: query,
    interval: 'weekly',
    newsletter: false
  });



  const prompt = searchPrompt(query)

  const handleSubmit: FormEventHandler = async (e) => {
    e.preventDefault();

    // somehow inertjajs doesn't return errors. use axios instead
    try {
      await axios.post(relativeRoute('search.save'), data)
      setIsSend(true)
    } catch (e: any) {
      const data = e.response.data;
      setErrors(data.errors)
    }
    if (onSubmit) {
      onSubmit(data);
    }
  };

  useEffect(() => {
    // if (isOpen && defaultValues) {
    //   setData({...data, ...defaultValues})
    // }
    if (isOpen && query) {
      setData({...data, query})
    }
    if (!isOpen) {
      setIsSend(false)
      reset();
    }
  }, [isOpen]);



  if (!isOpen) {
    return <></>
  }
  return <Modal title={'Bewaar zoekopdracht'} onCancel={onCancel}>

    {!prompt && <>
      Je hebt geen zoekopdracht gegeven.
      Sluit dit venster, vul enkele zoek parameters in en open opnieuw 'Bewaar zoekopdracht'.
    </>}
    {prompt && <form onSubmit={handleSubmit}>
        <fieldset disabled={isLoading}>
            <div>
                <label>Je zoekopdracht: </label>
              {prompt}
                <hr/>
            </div>
          {isSend && <div>
              Je zoekopdracht is opgeslagen. Je hebt een email ontvangen om de opdracht te bevestigen.<br/>
              Met deze link kun je ook je andere opdrachten beheren.
          </div>}
          {!isSend && <>
              <div>
                  <label>Je naam:
                      <TextInput
                          value={data.name}
                          onChange={(e) => setData('name', e.target.value)}
                      />
                  </label>
                  <InputError message={errors.name}/>
              </div>
              <div>
                  <label>
                      Je e-mailadres: &nbsp;

                      <TextInput
                          value={data.email}
                          onChange={(e) => setData('email', e.target.value)}
                      />
                  </label>
                  <InputError message={errors.email}/>
              </div>
              <div className={'hidden'}>
                  <label>
                      Hoe vaak wil je een email ontvangen? &nbsp;<br />
                      <label><input
                          type={'radio'}
                          name={'interval'}
                          value={'daily'}
                          checked={data.interval === 'daily'}
                          onChange={(e) => setData('interval', e.target.value as "daily" | "weekly")}
                      /> Dagelijks</label><br />
                      <label><input
                          type={'radio'}
                          name={'interval'}
                          value={'weekly'}
                          checked={data.interval === 'weekly'}
                          onChange={(e) => setData('interval', e.target.value as "daily" | "weekly")}
                      /> Wekelijks</label><br />

                  </label>
                  <InputError message={errors.email}/>
              </div>
            {/*<div>*/}

            {/*  <label>*/}
            {/*    <Checkbox*/}
            {/*      checked={data.newsletter}*/}
            {/*      onChange={(e) => setData('newsletter', e.target.checked)}*/}
            {/*    />*/}

            {/*    &nbsp;Wil je ook de nieuwsbrief ontvangen?*/}
            {/*  </label>*/}
            {/*  <InputError message={errors.newsletter}/>*/}
            {/*</div>*/}
              <footer>
                  <button type={"submit"}>
                    {isLoading && <i className="fa-solid fa-spinner fa-spin me-3"></i>}
                      Opslaan
                  </button>
              </footer>
          </>}
        </fieldset>
    </form>}

  </Modal>


}
